import { GhostButton } from 'ui/button';

import { SnippetReferenceFilterContainer } from './Styled';
import { UsageFilterMenu } from './UsageFilterMenu';
import { StateWithInactive } from './../types';

type Props = {
  selectedFilters: StateWithInactive;
  clearFilter: () => void;
  onFilterChange: (filter: StateWithInactive) => void;
};

export const SnippetReferenceFilter = ({ selectedFilters, clearFilter, onFilterChange }: Props) => {
  const canClearFilters = selectedFilters.length > 0;

  return (
    <SnippetReferenceFilterContainer>
      {canClearFilters && (
        <GhostButton
          data-test="clear-campaign-filters-button"
          id="clear-campaign-filters-button"
          onClick={clearFilter}
          tabIndex={0}
        >
          Clear
        </GhostButton>
      )}

      <UsageFilterMenu onSelect={onFilterChange} selectedFilters={selectedFilters} />

      {/* <SearchContainer>
                <InputSearch
                  id={'reference-search'}
                  onChange={setSearchInputValue}
                  placeholder={displayContent.searchPlaceholder}
                  value={searchInputValue}
                />
              </SearchContainer> */}
    </SnippetReferenceFilterContainer>
  );
};
